import { render, staticRenderFns } from "./EscrowAccount.vue?vue&type=template&id=2edf4a8a&scoped=true&"
import script from "./EscrowAccount.vue?vue&type=script&lang=js&"
export * from "./EscrowAccount.vue?vue&type=script&lang=js&"
import style0 from "./EscrowAccount.vue?vue&type=style&index=0&id=2edf4a8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edf4a8a",
  null
  
)

export default component.exports